import { ITokenNode } from "./formulaParser";
import { Token } from "./tokenizer";

export const findNodeByTokenData = (ln: ITokenNode, payload?: Token) =>
  ln.token.endIndex === payload?.endIndex &&
  ln.token.startIndex === payload?.startIndex &&
  ln.token.text === payload?.text &&
  ln.token.tokenType === payload?.tokenType;
